/* LIBRAIRIRES */
import React from 'react';
import './Footer.css';
import bands from '../../Assets/Pictos/bands.png';
import LinkSocialNetworks from '../LinkSocialNetworks/LinkSocialNetworks';

const Footer = () => {
    return (
        <footer className='footer'>
            <img src={bands} alt="" />
            <div className="footer-locationInfo-Container">
                <div className='footer-locationInfo'>
                    <h3>ADRESSE</h3>
                    <p>114, Avenue de Paris</p>
                    <p>94300 - Vincennes</p>
                </div>
                <div className='footer-locationInfo'>
                    <h3>HEURES D'OUVERTURES</h3>
                    <p>DU LUNDI AU JEUDI: 09H00 - 18H00</p>
                    <p>LE VENDREDI: 09H00 - 17H00</p>
                </div>
                <div className='footer-locationInfo'>
                    <h3>COORDONNEES</h3>
                    <p>TEL: 01.43.74.46.07</p>
                    <p>E-MAIL: CONTACT@AAAFIDUCIAIRE.FR</p>
                </div>
            </div>

            <div className="footer-businessDetails-Container">
                <LinkSocialNetworks />
                <p>N° Siret : 392 327 110 00046 - Code APE 6920Z N° TVA intracommunautaire FR 2639237110</p>
                <p><span className='registered-trademark'>c</span>MoshéFrydmann - 2023</p>
            </div>
        </footer>
    )
};

export default Footer;